export enum PointsOfInterestStorageKey {
  ADD_POINT_OF_INTEREST_FORM = 'addContractorForm',
}
